(function () {
  function applyLoeQa() {
    document.querySelectorAll('.home-tour-gift__copy > .button').forEach(function (button) {
      if (button.textContent.trim() !== 'Gift a Walking Tour') button.textContent = 'Gift a Walking Tour';
    });

    document.querySelectorAll('a[href="/products/west-hollywood-historic-walking-tour"]').forEach(function (card) {
      card.classList.remove('lae-tour-card--soon');
      var price = card.querySelector('.lae-tour-card__body strong');
      if (price) price.textContent = 'From $29.99';
    });

    document.querySelectorAll('.lae-tour-difference__heading h2, .lae-tour-difference__heading').forEach(function (heading) {
      var target = heading.matches('h2') ? heading : heading.querySelector('h2');
      if (target) target.textContent = 'A New Way to See LA.';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLoeQa);
  } else {
    applyLoeQa();
  }
  document.addEventListener('shopify:section:load', applyLoeQa);
})();
